<template>
  <div>
    <b-row>
      <b-col><h2 class="tsny_header">Question Categories</h2></b-col>
    </b-row>
    <b-row v-if="!questionCategories.length">
      <b-col>
        <p class="tsny_text">
          This course doesn't have any categories yet
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ul>
          <li
            v-for="(category, index) in questionCategories"
            :key="category._id"
          >
            <span @click="openUpdateCategoryModal(category)" class="tsny_icon"
              >{{ category.name }} <i class="fa fas fa-edit mx-2"
            /></span>
            <i
              class="fa fas fa-trash tsny_icon"
              @click="openDeleteCategoryModal(index, category)"
            />
            <ul>
              <li
                class="tsny_text"
                v-for="subcategory in category.subcategories"
                :key="subcategory.name"
              >
                ({{ subcategory.abbreviation }}) {{ subcategory.name }}
              </li>
            </ul>
          </li>
        </ul>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="tsny_button" @click="openCreateCategoryModal"
          >+ Add Category</b-button
        >
      </b-col>
    </b-row>

    <create-question-category-modal
      :course-id="courseId"
      @category-created="categoryCreated"
    />
    <update-question-category-modal
      :course-id="courseId"
      :category="selectedCategory"
    />
    <delete-question-category-modal
      :course-id="courseId"
      :category="selectedCategory"
      @category-deleted="categoryDeleted"
    />
  </div>
</template>

<script>
import CreateQuestionCategoryModal from "./CreateQuestionCategoryModal";
import UpdateQuestionCategoryModal from "./UpdateQuestionCategoryModal";
import DeleteQuestionCategoryModal from "./DeleteQuestionCategoryModal";

export default {
  name: "QuestionCategories",
  components: {
    DeleteQuestionCategoryModal,
    UpdateQuestionCategoryModal,
    CreateQuestionCategoryModal
  },
  props: {
    courseId: {
      type: String,
      default: null
    },
    questionCategories: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    selectedCategory: null,
    selectedIndex: null
  }),
  methods: {
    categoryCreated(category) {
      this.questionCategories.push(category);
    },
    categoryDeleted() {
      this.questionCategories.splice(this.selectedIndex, 1);
    },
    openCreateCategoryModal() {
      this.$bvModal.show("createCategoryModal");
    },
    openUpdateCategoryModal(category) {
      this.selectedCategory = category;
      this.$bvModal.show("updateCategoryModal");
    },
    openDeleteCategoryModal(index, category) {
      this.selectedCategory = category;
      this.selectedIndex = index;
      this.$bvModal.show("deleteCategoryModal");
    }
  }
};
</script>

<style scoped></style>
